export const COLORS_BY_LINE = new Map([
  ['214', '#DC2626'],    // red-600
  ['520', '#FBBF24'],    // yellow-400
  ['202', '#F97316'],    // orange-500
  ['307', '#0c7f55']     // green-600
]);

const getColorByLine = (linea) => {
  return COLORS_BY_LINE.get(linea) || '#6B7280';  // gray-500
}

export default getColorByLine;